<template>
    <div>
        <Header />
        <div class="wrapper">

            <!-- 管理者 -->
            <el-tabs type="card" @tab-click="handleClick" v-if="isAdmin">
                <el-tab-pane label="一般ユーザー">
                    <div class="main">

                        <div class="results">
                            <div class="border-bottom"><span class="number-of-result">{{ total }}</span>件が該当しました</div>
                        </div>

                        <!-- あとでここをコンポーネントにしてみる -->
                        <el-form ref="form" :model="form" label-width="120px">
                            <el-form-item label="表示数">
                                <el-select v-model="options.limit" @change="changeMaxLimit">
                                    <el-option
                                    v-for="limit in maxLimit"
                                    :key="limit.id"
                                    :label="limit.value"
                                    :value="limit.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>

                        <!-- 物件詳細 -->
                        <section class="property-section bg-grey">
                            <property-list
                                v-for="property in properties"
                                :key="property.id"
                                :property="property"
                                @login="viewProperty"
                                @pushFavorite="favorite"
                                @share="share"
                            />

                            <property-pagination
                                @clickPaginate="clickPaginate"
                                :pages="paginate"
                            />
                        </section>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="管理者">
                    <div class="main">

                        <div class="results">
                            <div class="border-bottom"><span class="number-of-result">{{ total }}</span>件が該当しました</div>
                        </div>

                        <el-form ref="form" :model="form" label-width="120px">
                            <el-form-item label="表示数">
                                <el-select v-model="options.limit" @change="changeMaxLimit">
                                    <el-option
                                    v-for="limit in maxLimit"
                                    :key="limit.id"
                                    :label="limit.value"
                                    :value="limit.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>

                        <!-- 物件詳細 -->
                        <section class="property-section bg-grey">
                            <property-list
                                v-for="property in properties"
                                :key="property.id"
                                @changePublicStatus="changePublicStatus"
                                :property="property"
                                isAdmin
                                @login="viewProperty"
                                @pushFavorite="favorite"
                                @edit="edit"
                            />

                             <property-pagination
                                @clickPaginate="clickPaginate"
                                :pages="paginate"
                            />
                        </section>
                    </div>
                </el-tab-pane>
            </el-tabs>

            <!-- 一般ユーザー -->
            <div class="main" v-else>

                <div class="results">
                    <div class="border-bottom"><span class="number-of-result">{{ total }}</span>件が該当しました</div>
                </div>

                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="表示数">
                        <el-select v-model="options.limit" @change="changeMaxLimit">
                            <el-option
                            v-for="limit in maxLimit"
                            :key="limit.id"
                            :label="limit.value"
                            :value="limit.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

                <!-- 物件詳細 -->
                <section class="property-section bg-grey">
                    <property-list
                        v-for="property in properties"
                        :key="property.id"
                        :property="property"
                        @login="viewProperty"
                        @pushFavorite="favorite"
                        @share="share"
                    />
                    <property-pagination
                        @clickPaginate="clickPaginate"
                        :pages="paginate"
                    />
                </section>
            </div>

            <!-- サイドバー -->
            <sidebar-condition
                @search="search"
            />

        </div>
        <login-modal
            :dialogVisible="modalShow"
            @close="closeModal"
            @login="toLogin"
        ></login-modal>

        <share-modal
            :dialogVisible="isShareModal"
            @close="closeShareModal"
            :property="shareProperty"
        />

        <save-property-modal
            :dialogFormVisible="isShowSavePropertyModal"
            title="物件情報を更新する"
            :form="editedProperty"
            @close="closeSavePropertyModal"
            @update="updateProperty"
        ></save-property-modal>
    </div>
</template>


<script>
import PropertyList from '../../components/List/PropertyList'
import PropertyPagination from '../../components/Pagination/PropertyPagination'
import SidebarCondition from "../../components/Sidebar/SidebarCondition";
import PropertyRepository from '../../backend/PropertyRepository'
import LoginModal from '../../components/organisms/modal/LoginModal'
import ShareModal from '../../components/organisms/modal/ShareModal'
import Header from '../../components/Header/Header'
import { maxLimit } from '../../definitions/search/max_limit'
import SavePropertyModal from '../../components/organisms/modal/SavePropertyModal'

export default {
    components: {
        PropertyList,
        PropertyPagination,
        SidebarCondition,
        LoginModal,
        Header,
        ShareModal,
        SavePropertyModal
    },
    data() {
        return {
            total: 0,
            paginate: {},
            properties: [],
            options: {
                newlyFrom: '',
                newlyTo: '',
                price_from: 0,
                price_to: 0,
                land_area_from: 0,
                land_area_to: 0,
                unit_price_from: 0,
                unit_price_to: 0,
                area: [],
                station_distance: 0,
                floor_area_ratio_from: 0,
                floor_area_ratio_to: 0,
                limit: 20
            },
            modalShow: false,
            activeName: 'first',
            checkList: [],
            isShareModal: false,
            shareProperty: null,
            sharePropertyId: null,
            isShowSavePropertyModal: false,
            editedProperty: {}
        }
    },
    mounted() {
        this.getProperties()
    },
    computed: {
        isAdmin() {
            return this.$store.getters['auth/getRole'] === 'admin'
        },
        maxLimit() {
            return maxLimit
        }
    },
    methods: {
        // 検索処理
        search(options) {

            this.options.newlyFrom = options.newlyFrom
            this.options.newlyTo = options.newlyTo
            this.options.price_from = options.priceFrom
            this.options.price_to = options.priceTo
            this.options.land_area_to = options.landAreaTo
            this.options.land_area_from = options.landAreaFrom
            this.options.unit_price_from = options.unitPriceFrom
            this.options.unit_price_to = options.unitPriceTo
            this.options.area = options.area
            this.options.station_distance = options.stationDistance
            this.options.floor_area_ratio_from = options.floorAreaRatioFrom
            this.options.floor_area_ratio_to = options.floorAreaRatioTo

            this.getProperties()

        },
        // 物件情報取得
        async getProperties(page = null, tabName = null) {
            const response = await PropertyRepository.getList(this.options, page, tabName)

            this.properties = response.data // 物件詳細
            this.total = response.total // 合計件数
            this.paginate = response //
        },
        // お気に入り
        async favorite(property) {
            const findProperty = (element) => element.id === property.id;
            const index = this.properties.findIndex(findProperty)
            let message = ''
            let response = ''

            // お気に入り解除
            if (property.favorites) {
                response = await PropertyRepository.unfavorite(property)
                message = 'お気に入りから削除しました'

            // お気に入り登録
            } else {
                response = await PropertyRepository.favorite(property)
                message = 'お気に入りに登録しました'
            }

            if (response.status === 200) {
                this.$message({
                    message: message,
                    type: 'success'
                })

                this.changeFavorite(index, property)
            }
        },
        // お気に入りの表示を切り替える
        changeFavorite(index, property) {
            this.properties[index].favorites = !property.favorites
        },
        // ページネーション押下
        clickPaginate(page) {
            this.getProperties(page, 1)
            this.scrollTo()
        },
        changeMaxLimit() {
            this.getProperties()
        },
        viewProperty() {
            this.modalShow = !this.modalShow
        },
        toLogin() {
            this.$router.push({ name: 'login' })
        },
        closeModal() {
            this.modalShow = false
        },
        async handleClick(tab) {
            await this.getProperties(null, tab.label)
        },
        updateEndOfPublication() {},
        // SNSシェア
        share(property) {
            this.isShareModal = true
            this.shareProperty = property
        },
        // シェアモーダル
        closeShareModal() {
            this.isShareModal = false
        },
        // 公開ステータスの変更
        async changePublicStatus(property) {
            const response = await PropertyRepository.changePublicStatus(property)

            if (response.status === 200) {
                this.$message({
                    message: '公開状況は正常に更新されました',
                    type: 'success'
                });
            } else {
                this.$message.error('公開状況の更新に失敗しました');
            }
        },
        scrollTo() {
            const element = document.getElementsByClassName('main')[0]
            const topDistance = element.offsetTop
            scrollTo(0, topDistance)
        },

        //////////////////////////////////
        // 物件を編集する
        async edit(property) {
            const response = await PropertyRepository.getDetailWithStr(property.id)
            this.editedProperty = response.property;
            this.isShowSavePropertyModal = true
        },

        closeSavePropertyModal() {
            this.isShowSavePropertyModal = false
        },

        async updateProperty(property) {
            const response = await PropertyRepository.update(property)

            if (response.status === 200) {
                this.isShowSavePropertyModal = false

                this.$message({
                    message: '物件情報が正常に更新されました',
                    type: 'success'
                });

                this.getProperties()
            }

            if (response.status === 422) {
                console.log(response)

                this.$message({
                    message: response.data.message,
                    type: 'error'
                });
            }
        }
    }
}
</script>


<style scoped>
.wrapper {
    width: 80%;
    display: flex;
    margin: 20px auto;
    justify-content: center;
}

.main {
    width: 95%;
    margin-right: 20px;
}
/*-------------result-------------------*/
.results {
    margin-bottom: 16px;
    text-align: left;
}

/*-------------result-------------------*/
.results {
    margin-bottom: 16px;
    text-align: left;
}

.border-bottom {
    border-bottom: 1px solid #707070;
}

.number-of-result {
    font-size: 30px;
    color: #FF3F3A;
}


@media screen and (max-width: 1000px) {

    .wrapper {
        width: 90%;
        flex-direction: column-reverse;
    }

    .main {
        width: 100%;
    }

    .side {
        margin-top: 100px;
        width: 100%;
    }

    .property-body {
        font-size: 10px;
    }

    .property-price {
        font-size: 15px;
    }
}


@media screen and (max-width: 600px) {
    .property-section {
        padding: 0;
    }

    .property-block {
        padding: 1rem 1rem 1rem 1rem;
    }

    .property-block figure {
        width: 115px;
        height: 100px;
    } 

    .property-thumb {
        width: 112px;
        height: 97px;
    }
}
</style>

<style>
.el-tabs{
    width: 100%;
}
.el-form-item__content {
    text-align: left;
}
</style>